export default "__VITE_ASSET__Ig1$t95h__"